
import { Component, Vue } from "vue-property-decorator";
import { Action, Getter, Mutation, State } from "vuex-class";
import Link from "@/components/Link.vue";
import P5 from "p5";
import Tone from "tone";

@Component({
  components: {
    Link
  },
})

export default class Posts extends Vue{
  @Mutation private setPreviousPage!: (name: any) => any;
  @Mutation private setCurrentPage!: (name: any) => any;
  @State private previousPage!: string;
  @State private currentPage!: string;

  private mounted(){
    if(this.$route.name!=null){
      this.setPreviousPage(this.currentPage);
      this.setCurrentPage(this.$route.name);
    }
    const script = function (p5: any) {    
      let poly : any;
      let bassSynth : any;
      const A = p5.uHeight/2.5;
      const bassPalette = ["#9b3939", "#635219", "#1b6b35", "#ba3968", "#9a5027", "#476f24", "#048267"];
      const padPalette = ["#cf4c4c", "#846d21", "#248c46", "#f34b88", "#c66735", "#5f8c36", "#1aa085"];
      const bassNotes = ["C1", "D1", "E1", "F1", "G1", "A1", "B1"];
      const padNotes = ["C3", "D3", "E3", "F3", "G3", "A3", "B1"];
      const chord : any = [];
      let lastChord : any = [];
      let bass : any, lastBass : any;
      let storedTime = 0;
      let legacyProportion = 0;
      let movement = 0;
      let rotation = 0;
      let started = false;

      function drawRing(){
        p5.noFill();
        p5.translate(p5.width/2, p5.height/2);
        movement+=0.5;
        rotation+=0.5;
        
        for(let i=0; i<360; i++){
          const x = 300*p5.cos(p5.radians(i-90));  
          const y = 300*p5.sin(p5.radians(i-90));
          const size = 200*p5.noise(1+p5.cos(p5.radians(i))+p5.cos(p5.radians(movement)), 1+p5.sin(p5.radians(i))+p5.sin(p5.radians(movement)));
          const hOff = 100*p5.noise(1+p5.cos(p5.radians(i))+p5.cos(p5.radians(movement)), 1+p5.sin(p5.radians(i))+p5.sin(p5.radians(movement)))-50;
          const vOff = 100*p5.noise(5+p5.cos(p5.radians(i))+p5.cos(p5.radians(movement)), 7+p5.sin(p5.radians(i))+p5.sin(p5.radians(movement)))-50;
          let R = 0;
          let G = 0;
          let B = 0;
          const p = [(0+rotation)%360, (120+rotation)%360, (240+rotation)%360];
          
          for(let j=0; j<p.length; j++){
            let d = p5.abs(p[j]-i);
            d = d > 240 ? 360-d : d;
            let intensity = 120-d;
            intensity = intensity < 0 ? 0 : intensity/120;
            R += (p5.red(chord[j])   * (1-legacyProportion) + p5.red(lastChord[j])   * legacyProportion)*intensity;
            G += (p5.green(chord[j]) * (1-legacyProportion) + p5.green(lastChord[j]) * legacyProportion)*intensity;
            B += (p5.blue(chord[j])  * (1-legacyProportion) + p5.blue(lastChord[j])  * legacyProportion)*intensity;
          }
          p5.stroke(R, G, B);
          p5.ellipse(x+hOff, y+vOff, size, size);
        }
      }

      function newChord(baseNote:any){
        legacyProportion=1;
        lastBass = bass;
        bass = bassPalette[baseNote];
        const chordN = [];
        switch(baseNote){
          case 0:
            chordN[0] = 0; chordN[1] = 2; chordN[2] = 4; break;
          case 1:
            chordN[0] = 1; chordN[1] = 3; chordN[2] = 5; break;
          case 2:
            chordN[0] = 2; chordN[1] = 4; chordN[2] = 6; break;
          case 3:
            chordN[0] = 0; chordN[1] = 3; chordN[2] = 5; break;
          case 4:
            chordN[0] = 1; chordN[1] = 4; chordN[2] = 6; break;
          case 5:
            chordN[0] = 0; chordN[1] = 2; chordN[2] = 5; break;
          case 6:
            chordN[0] = 1; chordN[1] = 3; chordN[2] = 6; break;
        }
        lastChord=chord;
        chord[0] = padPalette[chordN[0]];
        chord[1] = padPalette[chordN[1]];
        chord[2] = padPalette[chordN[2]];
        poly.triggerAttackRelease([padNotes[chordN[0]], padNotes[chordN[1]], padNotes[chordN[2]]], 3);
        bassSynth.triggerAttackRelease(bassNotes[baseNote], 3);
      }

      function start(){
        poly = new Tone.PolySynth(Tone.Synth).toDestination();
        bassSynth = new Tone.PolySynth(Tone.Synth).toDestination();
        p5.strokeWeight(3);
        newChord(0);
        lastBass=bass;
        lastChord=chord;
        started = true;
        storedTime = p5.millis();
      }
      
      p5.setup = (_:any) => {      
        const canvas = p5.createCanvas(p5.uWidth, p5.uHeight);
        canvas.parent("p5Canvas"); 
        p5.background(bassPalette[0]);
        p5.textAlign(p5.CENTER);
        p5.textSize(40);
        p5.text("Click to start", p5.width/2, p5.height/2);
        p5.text(p5.msg, p5.width/2, p5.height/2+60);
      }     

      p5.draw = (_:any) => {      
        if(started){
          const backgroundColor = p5.color(
            p5.red(bass)*(1-legacyProportion)+p5.red(lastBass)*legacyProportion,
            p5.green(bass)*(1-legacyProportion)+p5.green(lastBass)*legacyProportion,
            p5.blue(bass)*(1-legacyProportion)+p5.blue(lastBass)*legacyProportion
          );
          p5.background(backgroundColor);
          if(p5.millis()-storedTime>3000){
            storedTime = p5.millis();
            newChord(p5.int(p5.random(7)));
          }
          drawRing();
          legacyProportion = legacyProportion > 0 ? legacyProportion - 0.05 : 0;
        }
      }  

      p5.mouseClicked = (_:any) => {
        start();
      }
    }   
    
    const myP5 = new P5(script);
    myP5.msg="Amigoo";
    myP5.uWidth = document.body.clientWidth;
    myP5.uHeight = document.body.clientHeight-45;
  }
  
  private handleScreenClick(){
    const context = new AudioContext();
    context.resume();
  }
};
